<template>
  <v-card class="model-filters-card" elevation="3" variant="text">
    <v-card-title class="model-filters-title">
      <span>{{ $t('filter', 2).capitalize() }}</span>
      <v-spacer />
      <v-btn
        size="small"
        variant="text"
        :disabled="loadingModel || !viewerReady || !hasActiveFilters"
        @click="resetFilters"
      >
        {{ $t('buttons.reset') }}
      </v-btn>
    </v-card-title>
    <v-card-text class="model-filters-content">
      <div
        v-for="category in availableCategories"
        :key="category"
        class="filter-categories"
      >
        <div class="filter-category-title">{{ category }}</div>
        <div class="filter-category-actions">
          <v-btn
              class="category-filter-btn category-filter-btn-visibility"
              size="small"
              :variant="isCategoryHidden(category) ? 'flat' : 'outlined'"
              :color="isCategoryHidden(category) ? 'primary' : undefined"
              :disabled="loadingModel || !viewerReady"
              @click="toggleCategoryVisibility(category)"
          >
            {{ isCategoryHidden(category) ? $t('show').capitalize() : $t('hide').capitalize() }}
          </v-btn>
          <v-btn
              class="category-filter-btn category-filter-btn-isolation"
              size="small"
              :variant="isCategoryIsolated(category) ? 'flat' : 'outlined'"
              :color="isCategoryIsolated(category) ? 'primary' : undefined"
              :disabled="loadingModel || !viewerReady"
              @click="toggleCategoryIsolation(category)"
          >
            {{ isCategoryIsolated(category) ? $t('unisolate').capitalize() : $t('isolate').capitalize() }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

const props = defineProps({
  loadingModel: {
    type: Boolean,
    default: false
  }
});

const store = useStore();
const viewerReady = computed(() => Boolean(store.state.modelViewer?.viewer));
const loadingModel = computed(() => props.loadingModel);
const availableCategories = computed(() => store.getters.getViewerAvailableCategories || []);
const activeCategoryIsolations = computed(() => store.getters.getViewerActiveCategoryIsolations || []);
const hiddenCategories = computed(() => store.getters.getViewerHiddenCategories || []);
const hasActiveFilters = computed(() => activeCategoryIsolations.value.length > 0 || hiddenCategories.value.length > 0);

const isCategoryIsolated = (category) => {
  return activeCategoryIsolations.value.includes(category);
};

const isCategoryHidden = (category) => {
  return hiddenCategories.value.includes(category);
};

const toggleCategoryIsolation = (category) => {
  store.dispatch("toggleCategoryIsolation", {
    category: category,
    active: !isCategoryIsolated(category)
  });
};

const toggleCategoryVisibility = (category) => {
  store.dispatch("toggleCategoryVisibility", {
    category: category,
    active: !isCategoryHidden(category)
  });
};

const resetFilters = () => {
  store.dispatch("resetCategoryFilters");
};
</script>

<style scoped>
.model-filters-card {
  max-height: 512px;
  padding: 10px 10px;
}

.model-filters-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.model-filters-content {
  max-height: 448px;
  overflow-y: auto;
}

.filter-categories {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.filter-category-title {
  flex: 1;
  white-space: nowrap;
}

.filter-category-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.category-filter-btn {
  min-width: 0;
}

.category-filter-btn-visibility {
  width: 10ch;
}

.category-filter-btn-isolation {
  width: 14ch;
}
</style>

